module.exports = __webpack_public_path__ + "static/media/receivedProducts.29721301.svg";